import * as React from 'react'

import { RadioInputProps } from '@thg-commerce/gravity-elements/RadioGroup/types'

import {
  FiveStarsContainer,
  TwoStarsContainer,
  HiddenRadioButton,
  OptionRadioLabel,
  StyledSelectedStarIcon,
  StyledStarIcon,
} from './styles'

export type StarIconProps = {
  rating: string
  selected: boolean
}

export type StarRatingRadioInputProps = Pick<
  RadioInputProps,
  'name' | 'value' | 'radioGroupState' | 'setGroupState'
>

export const StarIcon = (props: StarIconProps) => {
  const createMultipleStyledStarIcon = (amount: number) =>
    Array.from({ length: amount }, (_, i) => i + 1).map((index) => {
      return props.selected ? (
        <StyledSelectedStarIcon key={index} />
      ) : (
        <StyledStarIcon key={index} />
      )
    })
  const rating = parseInt(props.rating, 10)

  if (rating === 5) {
    return (
      <FiveStarsContainer aria-hidden>
        <div>{createMultipleStyledStarIcon(3)}</div>
        <TwoStarsContainer>{createMultipleStyledStarIcon(2)}</TwoStarsContainer>
      </FiveStarsContainer>
    )
  }
  return <div aria-hidden>{createMultipleStyledStarIcon(rating)}</div>
}

export const StarRatingRadioInput = (props: StarRatingRadioInputProps) => {
  const radioId = `${props.name}-${props.value}`
  const isValueSelected = props.value === props.radioGroupState

  return (
    <React.Fragment>
      <HiddenRadioButton
        name={props.name}
        value={props.value}
        type="radio"
        id={radioId}
        aria-label={`${props.value} Star`}
        data-testid={`star-rating-radio-label-${radioId}${
          isValueSelected ? '-selected' : ''
        }`}
        onClick={() => {
          props.setGroupState && props.setGroupState(props.value)
        }}
      />
      <OptionRadioLabel
        htmlFor={radioId}
        selected={isValueSelected}
        value={props.value}
      >
        {StarIcon({ rating: props.value, selected: isValueSelected })}
      </OptionRadioLabel>
    </React.Fragment>
  )
}
